import {resolve} from "path-browserify";
import {hasPermission} from "@/utils/permission";
import {isExternal} from "@/utils/validate";
import qs from "qs";

/**
 * @description 根据roles数组拦截路由
 * @param routes 路由
 * @param baseUrl 基础路由
 * @returns {[]}
 */
export function filterRoutes(routes, baseUrl = "/") {
  return routes
    .filter((route) =>
      route.meta && route.meta.guard ? hasPermission(route.meta.guard) : true
    )
    .map((route) => {
      route = {...route};
      route.path =
        route.path !== "*" && !isExternal(route.path)
          ? resolve(baseUrl, route.path)
          : route.path;
      if (route.children && route.children.length > 0) {
        route.children = filterRoutes(route.children, route.path);
        if (route.children.length > 0) {
          route.childrenNameList = route.children.flatMap(
            (_) => _.childrenNameList
          );
          if (!route.redirect) {
            const cloneChildren = route.children.filter(child => child.meta && !child.meta.hidden)
            route.redirect = cloneChildren[0].redirect
              ? cloneChildren[0].redirect
              : cloneChildren[0].path;
          }
        }
      } else route.childrenNameList = [route.name];
      return route;
    });
}

/**
 * 根据path路径获取matched
 * @param routes 菜单routes
 * @param name 路由名
 * @returns {*} matched
 */
export function handleMatched(routes, name) {
  return routes
    .filter((route) => route.childrenNameList && route.childrenNameList[0] && route.childrenNameList.indexOf(name) + 1)
    .flatMap((route) =>
      route.children && route.children[0] ? [route, ...handleMatched(route.children, name)] : [route]
    );
}

/**
 * 根据当前route获取激活菜单
 * @param route 当前路由
 * @returns {string|*}
 */
export function handleActivePath(route) {
  const {meta} = route;
  if (meta.activeMenu) return meta.activeMenu;
  return route.query && Object.keys(route.query).length
    ? `${route.path}?${qs.stringify(route.query)}`
    : route.path;
}
